import { combineReducers } from 'redux';

import positionMarkersReducer from './reducers/positionMarkersReducer';
import draggableCardsReducer from './reducers/draggableCardsReducer';
import interactionReducer from './reducers/interactionReducer';
import screenStateReducer from './reducers/screenStateReducer';

export const reducerCollection = {
  positionMarkersReducer,
  draggableCardsReducer,
  interactionReducer,
  screenStateReducer,
};

export default combineReducers({ ...reducerCollection });
